// Since jquery.easing loaded into global defined jQuery object
const { jQuery } = window;

/**
 * Class for drawer menu.
 *
 *   .drawer-menu
 *   #is-drawer-menu-*
 *   .is-drawer-menu-*
 *   #js-drawer-menu-*
 *   .js-drawer-menu-*
 */
export default class DrawerMenu {
  constructor($element, options) {
    this.$element = $element;
    this.options = options;
    this.config = Object.assign({}, DrawerMenu.defaultOptions(), this.options);
  }

  buildMenu() {
    const $drawerMenu = jQuery("#is-drawer-menu");

    if (this.config.menu) {
      if (Array.isArray(this.config.menu)) {
        this.config.menu.forEach((element, index) => {
          $drawerMenu.append(
            jQuery(element).clone().addClass(`${this.config.menuId}-${index}`),
          );
          jQuery(element).hide();
        });
      } else {
        $drawerMenu.append(
          jQuery(this.config.menu)
            .clone()
            .addClass(`${this.config.menuId}-0`)
            .removeAttr("id"),
        );
        jQuery(this.config.menu).hide();
      }
    }
  }

  cssTranslateX($element, size) {
    jQuery($element).transition({ x: size }, 250, "ease", () => {
      if (this.$element.hasClass("is-drawer-menu-close")) {
        this.$element.removeClass("is-drawer-menu-animating");
      }
      if (
        this.config.currentTarget.type === "list-item" &&
        this.config.currentTarget.url
      ) {
        jQuery(window.location).attr("href", this.config.currentTarget.url);
      }
    });
  }

  cssAnimationMenuToggle() {
    const $page = jQuery(`#${this.config.pageId}`);
    const $overlay = jQuery("#js-drawer-menu-overlay");
    const duration = 400;
    const $footer = jQuery(`#${this.config.footerId}`);
    const footerPositionY = $footer.offset().top;

    this.$element.addClass("is-drawer-menu-animating");

    if (this.$element.hasClass("is-drawer-menu-open")) {
      this.$element.removeClass("is-drawer-menu-open");
      this.$element.addClass("is-drawer-menu-close");
      this.cssTranslateX($page, "0px");
      $overlay.fadeTo(duration, 0, () => {
        $overlay.css("visibility", "hidden");
        $footer.css("bottom", 0);
        $footer.css("top", "auto");
      });
    } else {
      this.$element.addClass("is-drawer-menu-open");
      this.$element.removeClass("is-drawer-menu-close");
      $overlay.css("visibility", "visible").fadeTo(duration, 0.1);
      this.cssTranslateX($page, `-${this.config.menuWidth}px`);
      $footer.css("bottom", "auto");
      $footer.css("top", footerPositionY);
    }
  }

  static defaultOptions() {
    return {
      pageId: "is-drawer-menu-target-content",
      footerId: "js-drawer-menu-target-footer",
      menu: "",
      menuWidth: 210,
      menuBar: "",
      currentTarget: {
        // Type of clicked element ('list-item', 'button', 'overlay', undefined)
        type: undefined,
        // URL to transit
        url: undefined,
      },
    };
  }

  setCSS() {
    jQuery("#js-drawer-menu-overlay").css({
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      background: "#000",
      display: "none",
      "z-index": 99,
    });
    jQuery("html, body").css("height", "100%");
    if (this.config.menuBar) {
      jQuery(this.config.menuBar).css({ position: "fixed" });
    }
  }

  setLayout() {
    // Setup html element
    this.$element
      .find(`#${this.config.pageId}`)
      .before('<div id ="is-drawer-menu" />');
    jQuery(`#${this.config.pageId}`).prepend(
      '<div id="js-drawer-menu-overlay" />',
    );

    this.buildMenu();
    this.setCSS();

    jQuery("#is-drawer-menu-button").on("click", (e) => {
      e.preventDefault();
      this.config.currentTarget.type = "button";
      this.config.currentTarget.url = undefined;
      this.cssAnimationMenuToggle();
    });
    jQuery("#js-drawer-menu-overlay").on("click", (e) => {
      e.preventDefault();
      this.config.currentTarget.type = "overlay";
      this.config.currentTarget.url = undefined;
      this.cssAnimationMenuToggle();
    });
    jQuery(".js-drawer-menu-list-item > a").on("click", (e) => {
      e.preventDefault();
      this.config.currentTarget.type = "list-item";
      this.config.currentTarget.url = jQuery(e.currentTarget).attr("href");
      this.cssAnimationMenuToggle();
    });
  }

  setup() {
    if (jQuery(this.config.menuId).length === 0) {
      this.setLayout();
    }
  }
}
